import React from 'react';

import { colors } from '@atlaskit/theme';

const NoIncidentWorkflowsMessage = ({ utmContent }) => {
  const href = `https://support.pagerduty.com/docs/incident-workflows?utm_source=jira_server_integration&utm_content=${utmContent}`;
  return (
    (
      <p style={{ color: colors.text }}>
      No workflows found. Learn how to create one
        {' '}
        <a style={{ color: colors.link, textDecoration: 'underline' }}
          href={href}
          target="_blank"
          rel="noreferrer">
          here
        </a>.
      </p>
    )
  );
};

export default NoIncidentWorkflowsMessage;
